module.exports = __webpack_public_path__ + "media/images/sp/plans/reason_04-08da81642a8452ed83e00e7afbce812a.jpg";